import React, { useState, useEffect } from 'react';
import { ListGroup, ListGroupItem } from 'react-bootstrap';

import '../../../styles/TableStats.css';

export default function TableStats() {
    const [totalContacts, setTotalContacts] = useState();
    const [passedContacts, setPassedContacts] = useState();
    const [failedContacts, setFailedContacts] = useState();
    const [onHoldContacts, setOnHoldContacts] = useState();
    const [activeContacts, setActiveContacts] = useState();
    const [inactiveContacts, setInactiveContacts] = useState();

    useEffect(() => {
        fetch('api/member/totalContactCount')
            .then(
                response => {
                    response.json().then(
                        json => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors)
                            setTotalContacts(json.message);
                        }
                    )
                }
            )
            .catch(
                error => {
                    console.log(error);
                    console.log("couldnt get total contact count.");
                }
            );
        fetch('api/member/totalPassedMemberCount')
            .then(
                response => {
                    response.json().then(
                        json => {
                            if(json.errors !== null && json.errors !== "") alert(json.errors)
                            setPassedContacts(json.message);
                        }
                    )
                }
            )
            .catch(
                error => {
                    console.log(error);
                    console.log("couldnt get passed contact count.");
                }
            );

        fetch('api/member/totalFailedMemberCount')
            .then(
                response => {
                    response.json().then(
                        json => {
                            if(json.errors !== null && json.errors !== "") alert(json.errors)
                            setFailedContacts(json.message);
                        }
                    )
                }
            )
            .catch(
                error => {
                    console.log(error);
                    console.log("couldnt get Failed contact count.");
                }
            );

        fetch('api/member/totalOnHoldMemberCount')
            .then(
                response => {
                    response.json().then(
                        json => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors)
                            setOnHoldContacts(json.message);
                        }
                    )
                }
            )
            .catch(
                error => {
                    console.log(error);
                    console.log("couldnt get OnHold contact count.");
                }
            );

        fetch('api/member/totalInactiveContactCount')
            .then(
                response => {
                    response.json().then(
                        json => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors)
                            setInactiveContacts(json.message);
                        }
                    )
                }
            )
            .catch(
                error => {
                    console.log(error);
                    console.log("couldnt get Inactive contact count.");
                }
            );

        fetch('api/member/totalActiveContactCount')
            .then(
                response => {
                    response.json().then(
                        json => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors)
                            setActiveContacts(json.message);
                        }
                    )
                }
            )
            .catch(
                error => {
                    console.log(error);
                    console.log("couldnt get Active contact count.");
                }
            );
    }, []);

    const variant = "info";
    return (
        <ListGroup className="table-stats-buttons">
            <ListGroupItem
                    className="individual-stat"
                style={{fontSize:12}}
                    variant={variant}
                >
                    <strong>Total: </strong>{totalContacts}
                </ListGroupItem>
            <ListGroupItem
                    className="individual-stat"
                style={{ fontSize: 12 }}
                    variant={variant}
                >
                    <strong>Passed: </strong> {passedContacts}
                </ListGroupItem>
                <ListGroupItem
                className="individual-stat"
                style={{ fontSize: 12 }}
                    variant={variant}
                >
                    <strong>Failed: </strong>{failedContacts}
            </ListGroupItem>
            <ListGroupItem
                className="individual-stat"
                style={{ fontSize: 12 }}
                    variant={variant}
                >
                    <strong>On Hold: </strong>{onHoldContacts}
            </ListGroupItem>
            <ListGroupItem
                className="individual-stat"
                style={{ fontSize: 12 }}
                    variant={variant}
                >
                    <strong>Active: </strong>{activeContacts}
            </ListGroupItem>
            <ListGroupItem
                className="individual-stat"
                style={{ fontSize: 12 }}
                    variant={variant}
                >
                    <strong>Inactive: </strong>{inactiveContacts}
            </ListGroupItem>
        </ListGroup>
    );
}